export default "__VITE_ASSET__C6CvAuut__"